// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__0veTD","cards__img":"Cards_cards__img__nPq6r","title":"Cards_title__92P0A","description":"Cards_description__QzL3X"};